import { createContext, useContext, } from 'react';
export const OsdContext = createContext({});
export const useOsd = () => {
    return useContext(OsdContext);
};
export const OsdContextProvider = OsdContext.Provider;
